import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  SaveButton,
  Toolbar,
  useRecordContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const UserEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const UserTitle = () => {
  const record = useRecordContext();
  return (
    <span>
      Edit User: {record?.username ? `@${record.username}` : record?.first_name}
    </span>
  );
};

export const UserEdit = () => (
  <Edit title={<UserTitle />}>
    <SimpleForm toolbar={<UserEditToolbar />}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Edit administrative settings for this user
        </Typography>
      </Box>

      <TextInput
        source="admin_notes"
        multiline
        rows={4}
        fullWidth
        label="Admin Notes"
        helperText="Internal notes about this user (visible only to admins)"
      />

      <BooleanInput
        source="is_blacklisted"
        label="Ban User"
        helperText="Banned users cannot participate in events or place bets"
      />
    </SimpleForm>
  </Edit>
);
